import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare /organization/admin → the first tab.
export const Route = createFileRoute('/_app/organization/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/organization/admin/taxonomy', search: true })
  },
})
